import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboardIcon, PackageIcon, UsersIcon, TruckIcon, WalletIcon, ClipboardPlusIcon, BarChart3Icon, SettingsIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { LanguageContext } from '../App';
import { Tooltip } from './ui/Tooltip';
export const MobileNav: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  const menuItems = [{
    id: 'dashboard',
    path: '/dashboard',
    icon: <LayoutDashboardIcon size={20} data-id="element-650" />,
    label: language === 'en' ? 'Dashboard' : 'لوحة التحكم'
  }, {
    id: 'orders',
    path: '/orders',
    icon: <PackageIcon size={20} data-id="element-651" />,
    label: language === 'en' ? 'Orders' : 'الطلبات'
  }, {
    id: 'users',
    path: '/users',
    icon: <UsersIcon size={20} data-id="element-652" />,
    label: language === 'en' ? 'Users' : 'المستخدمين'
  }, {
    id: 'drivers',
    path: '/drivers',
    icon: <TruckIcon size={20} data-id="element-653" />,
    label: language === 'en' ? 'Drivers' : 'السائقين'
  }, {
    id: 'wallet',
    path: '/wallet',
    icon: <WalletIcon size={20} data-id="element-654" />,
    label: language === 'en' ? 'Wallet' : 'المحفظة'
  }, {
    id: 'manual-booking',
    path: '/manual-booking',
    icon: <ClipboardPlusIcon size={20} data-id="element-655" />,
    label: language === 'en' ? 'Booking' : 'الحجز'
  }, {
    id: 'reports',
    path: '/reports',
    icon: <BarChart3Icon size={20} data-id="element-656" />,
    label: language === 'en' ? 'Reports' : 'التقارير'
  }, {
    id: 'settings',
    path: '/settings',
    icon: <SettingsIcon size={20} data-id="element-657" />,
    label: language === 'en' ? 'Settings' : 'الإعدادات'
  }];
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-10" data-id="element-658">
      <div className="grid grid-cols-4 h-16" data-id="element-659">
        {menuItems.slice(0, 4).map(item => <Tooltip key={item.id} content={item.label} side="top" data-id="element-660">
            <NavLink to={item.path} className={({
          isActive
        }) => `flex flex-col items-center justify-center text-xs ${isActive ? 'text-congress-blue-600' : 'text-gray-500'}`} data-id="element-661">
              {({
            isActive
          }) => <>
                  <motion.div whileHover={{
              scale: 1.1
            }} whileTap={{
              scale: 0.9
            }} data-id="element-662">
                    {item.icon}
                  </motion.div>
                  <span className="mt-1" data-id="element-663">{item.label}</span>
                  {isActive && <motion.div className="absolute top-0 w-1/4 h-0.5 bg-congress-blue-600" layoutId="mobileNavIndicator" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.2
            }} data-id="element-664" />}
                </>}
            </NavLink>
          </Tooltip>)}
      </div>
    </div>;
};